import './app.css'
import Header from './components/Header'
import WSCCard from './components/WSCCard'
import Footer from './components/Footer'

export default function App() {
  return (
    <>
      <Header />
      <WSCCard />
      <Footer />
    </>
  )
}
